<template>
  <v-container fluid class="pa-0">

    <v-row dense no-gutters align="center"
      style="height:48px;background:#f6f6f6;width:100%;color:#212121; border-style:solid; border-width:0px 0px 2px 0px;border-color:#e9e9e9">
      <a @click="runLogin">
      <v-avatar class="ml-5" :tile="true" width="170" height="24" >
        <img :src="require('@/assets/logo.png')" alt="logo">
      </v-avatar>
      </a>
    </v-row>

    <v-row align="center" justify="center" class="ma-10">
      <v-col class="join_round pl-10 pr-10" cols="12" md="5" xs="12" sm="12">

      <v-row dense no-gutters align="center" justify="center" class="mt-3 mb-10">
        <img width="160" height="20" :src="require('@/assets/logo.png')" alt="logo">
        <label style="color:#000000;font-size:20px;font-weight: bold">&nbsp;{{$t('pass_msg1')}}</label>
      </v-row>

      <v-stepper
        v-model="steplevel"
        vertical
        >
        <v-stepper-step
          :complete="steplevel > 1"
          step="1"
          >
          {{$t('pass_msg2')}}
        </v-stepper-step>

        <v-stepper-content step="1">
          <small>{{$t('pass_msg3')}}</small>          
          <v-text-field 
            v-model="user_id"
            dense single-line clearable
            maxlength="20" counter
            :placeholder="$t('pass_msg4')"
            outlined 
            color="red" 
            class="mt-3 mb-3"
            :hint="$t('pass_msg5')"
            :rules="[value => !this.pattern.test(value) || $t('join_notemail_rule'), value => !value || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value) || $t('pass_msg6')]"
            />
          <v-btn
            color="primary" rounded class="mr-3"
            @click="sendcode"
            >
            {{$t('pass_msg7')}}
          </v-btn>
          <v-btn color="primary" rounded @click="cancel">{{$t("common_cancel")}}</v-btn>
        </v-stepper-content>

        <v-stepper-step
          :complete="steplevel > 2"
          step="2"
          >
          {{$t('pass_msg8')}}
        </v-stepper-step>
        <v-stepper-content step="2">
          <small>{{$t('pass_msg9')}}</small>          
          <v-text-field 
            v-model="signcode"
            dense single-line clearable
            maxlength="6" counter
            :placeholder="$t('pass_msg10')"
            outlined 
            color="red"
            class="mt-3 mb-3"
            :hint="$t('pass_msg11')"
            :rules="[value => !value || !/[^0-9]/.test(value) || $t('pass_msg12')]"
            />
          <v-btn
            color="primary" rounded class="mr-3"
            @click="checkcode"
          >
          {{$t('pass_msg13')}}
          </v-btn>
          <v-btn color="primary" rounded @click="cancel">{{$t("common_cancel")}}</v-btn>
        </v-stepper-content>

        <v-stepper-step
          :complete="steplevel > 3"
          step="3"
          >
          {{$t('pass_msg14')}}
        </v-stepper-step>

        <v-stepper-content step="3">
          <small>{{$t('pass_msg15')}}</small>          
          <v-text-field
            v-model="pass1" class="mt-3"
            dense single-line clearable
            maxlength="30" counter 
            :placeholder="$t('pass_msg16')"
            :hint="$t('pass_msg17')"
            outlined height="43"
            color="red"
            type="password" 
            />
          <v-text-field
            v-model="pass2"
            maxlength="30" counter
            dense single-line clearable
            :placeholder="$t('pass_msg18')"
            :hint="$t('pass_msg17')"
            outlined height="43"
            color="red"
            type="password"
            />
          <v-btn
            color="primary" rounded class="mr-3"
            @click="changepass"
          >
          {{$t('pass_msg14')}}
          </v-btn>
          <v-btn color="primary" rounded @click="cancel">{{$t("common_cancel")}}</v-btn>
        </v-stepper-content>

      </v-stepper>

    </v-col>
  </v-row>

  </v-container>
</template>


<script>
export default {
    
    data: () => ({
      steplevel: 1,
      signcode: "",
      user_id:"",
      pass1:"",
      pass2:"",
      useridx:"",
      pattern : /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    }),

    methods: {

      cancel(){
        this.$confirm(this.$t('pass_msg21'))
        .then(() => {
          this.$router.push("/Login");
        });
      },

      runLogin(){
        this.$router.push("/Login");
      },

      sendcode(){
        //인증코드 발송
        const accntValfirst = /^[a-z]/g;
        if(!accntValfirst.test(this.user_id)){
          this.$alert(this.$t('pass_msg22'));
          return;
        }
        const accntvalidation = /^[a-z]+[a-z0-9]{3,29}$/g;
        if(!accntvalidation.test(this.user_id)){
          this.$alert(this.$t('pass_msg23'));
          return;
        }

          this.$http.post(this.$host+'/ime/ReqPassCode',{
              ADMIN_IDX: 1
            , ACCNT: this.user_id
            , LAN_CODE:this.$i18n.locale
          })
          .then((result)=>{
            if(result.data.resultCode == 0){
              this.useridx = result.data.resultData;
              this.steplevel = 2;
            }else{
              this.$alert(result.data.resultMsg);
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.$alert(this.$t('pass_msg24'));
          });
        
      },

      checkcode(){

        const numberVal = /^[0-9]/;
        if(this.signcode  == undefined || this.signcode.length < 1 || this.signcode.length > 6){
          this.$alert(this.$t('pass_msg25'));
          return;
        } 
        if(!numberVal.test(this.signcode)){
          this.$alert(this.$t('pass_msg26'));
          return;
        } 

        this.$http.post(this.$host+'/ime/CheckPassCode',{
            ADMIN_IDX: 1
          , USER_IDX: this.useridx
          , SIGNCODE: this.signcode
          , LAN_CODE:this.$i18n.locale
        })
        .then((result)=>{
          if(result.data.resultCode == 0){
            this.steplevel = 3;
          }else{
            this.$alert(result.data.resultMsg);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.$alert(this.$t('pass_msg24'));
        });
      },

      changepass(){

        const passVal = /^[a-zA-Z0-9!@#$%^&*()]{7,29}/;
        if(this.pass1  == undefined || this.pass1.length < 1 || this.pass1.length > 30){
          this.$alert(this.$t('pass_msg28'));
          return;
        } 
        if(!passVal.test(this.pass1)){
          this.$alert(this.$t('pass_msg29'));
          return;
        } 
        if(this.pass2  == undefined || this.pass2.length < 1 || this.pass2.length > 30){
          this.$alert(this.$t('pass_msg28'));
          return;
        } 
        if(!passVal.test(this.pass2)){
          this.$alert(this.$t('pass_msg31'));
          return;
        } 
        if(this.pass1 != this.pass2){
          this.$alert(this.$t('pass_msg32'));
          return;
        }

          this.$http.post(this.$host+'/ime/UserAcntUpdatePW',{
              ADMIN_IDX: 1
            , USER_IDX: this.useridx
            , PW: this.pass1
          })
          .then((result)=>{
            if(result.data.resultCode == 0){
              this.$alert(this.$t('pass_msg33')).then(()=>{
                this.$router.push("/Login");
              });
            }else{
              this.$alert(this.$t('pass_msg34'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.$alert(this.$t('pass_msg24'));
          });
      },

    },

    mounted(){
      
    },

    created(){

    }


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

  .join_round{
    background-color: white !important;
    border-radius: 20px !important; 
    border-color:#4e6ef7 !important; 
    border-style:solid !important; 
    border-width:1px 1px 1px 1px !important;
  }

</style>